import { NavList } from '@cpm-pr1618001/ng-design-lib';
import { createAction, props } from '@ngrx/store';
import { UpdateProfileInfoPayload } from '../state/settings.state';

export const loadSettingsTabs = createAction('[Settings] LOAD_SETTINGS_TABS');

export const loadSettingsTabsSuccess = createAction(
  '[Settings] LOAD_SETTINGS_TABS_SUCCESS',
  props<{ tabs: NavList[] }>(),
);

export const updateProfileInfo = createAction(
  '[Settings] UPDATE_PROFILE_INFO',
  props<{ payload: UpdateProfileInfoPayload; userId: number }>(),
);

export const updateProfileInfoSuccess = createAction(
  '[Settings] UPDATE_PROFILE_INFO_SUCCESS',
);

export const updateProfileInfoError = createAction(
  '[Settings] UPDATE_PROFILE_INFO_ERROR',
);

export const resetUpdateProfileInfoStatus = createAction(
  '[Settings] RESET_UPDATE_PROFILE_INFO_STATUS',
);

export const sendDeleteVerificationCode = createAction(
  '[Settings] SEND_DELETE_VERIFICATION_CODE',
  props<{ userId: number; emailId: string }>(),
);

export const sendDeleteVerificationCodeSuccess = createAction(
  '[Settings] SEND_DELETE_VERIFICATION_CODE_SUCCESS',
);

export const sendDeleteVerificationCodeError = createAction(
  '[Settings] SEND_DELETE_VERIFICATION_CODE_ERROR',
);

export const resetSendDeleteVerificationCodeStatus = createAction(
  '[Settings] RESET_SEND_DELETE_VERIFICATION_CODE_STATUS',
);

export const deleteAccount = createAction(
  '[Settings] DELETE_ACCOUNT',
  props<{ userId: number; emailId: string; verificationCode: string }>(),
);

export const deleteAccountSuccess = createAction(
  '[Settings] DELETE_ACCOUNT_SUCCESS',
);

export const deleteAccountError = createAction(
  '[Settings] DELETE_ACCOUNT_ERROR',
  props<{ errorMessage?: string }>(),
);

export const resetDeleteAccountStatus = createAction(
  '[Settings] RESET_DELETE_ACCOUNT_STATUS',
);

export const resetDeleteAccountModalState = createAction(
  '[Settings] RESET_DELETE_ACCOUNT_MODAL_STATE',
);
